import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

// Define the base endpoint for location
const LOCATION_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.LOCATION,
  false // No tenant ID in the base URL
);

export const getStateData = ({ countryId }) =>
  client.get(`${LOCATION_BASE}/list?level_type=2&parent_id=${countryId}`);

export const getDistrictData = ({ stateId }) =>
  client.get(`${LOCATION_BASE}/list?level_type=3&parent_id=${stateId}`);

export const getSubCountyData = ({ districtId, searchText = '', tenantId }) =>
  client.get(`${LOCATION_BASE}/list`, {
    params: {
      level_type: 4,
      ...(districtId && { parent_id: districtId }),
      ...(searchText && { search_text: searchText }),
      ...(tenantId && { tenant_id: tenantId }),
      is_active: true
    }
  });

export const getCountryData = () =>
  client.get(`${LOCATION_BASE}/list?level_type=1`);

export const getParishData = ({ subCountyId, searchText = '', tenantId }) =>
  client.get(`${LOCATION_BASE}/list`, {
    params: {
      level_type: 5,
      ...(subCountyId && { parent_id: subCountyId }),
      ...(searchText && { search_text: searchText }),
      ...(tenantId && { tenant_id: tenantId }),
      is_active: true
    }
  });

export const getVillageData = ({ parishId, searchText = '', tenantId }) =>
  client.get(`${LOCATION_BASE}/list`, {
    params: {
      level_type: 6,
      ...(parishId && { parent_id: parishId }),
      ...(searchText && { search_text: searchText }),
      ...(tenantId && { tenant_id: tenantId }),
      is_active: true
    }
  });
